import React from "react";
import ListaRetiros from "./ListaRetiros";

function SolicitudRetiro() {
    return <ListaRetiros initialTab="solicitud" />;
}

export default SolicitudRetiro;